import { useTranslation } from 'react-i18next';
import {
  PrivacyPolicyWrapper,
  TitlePage,
  PrivacyRuleText,
  TitleSection, 
  SectionList,
} from './styled';

export const PrivacyPolicy = () => {
  const { t } = useTranslation();
    
  return (
    <PrivacyPolicyWrapper>
      <TitlePage>{t('privacyPolicy')}</TitlePage>
      <PrivacyRuleText>{t('aboutPrivacy')}</PrivacyRuleText>
      <PrivacyRuleText>{t('additionalQuestionPrivacy')}</PrivacyRuleText>
      <PrivacyRuleText>{t('infoAboutPrivacy')}</PrivacyRuleText>
      <TitleSection>{t('Consent')}</TitleSection>
      <PrivacyRuleText>{t('whatYouAccept')}</PrivacyRuleText>
      <TitleSection>{t('whatWeCollect')}</TitleSection>
      <PrivacyRuleText>{t('personalInfo')}</PrivacyRuleText>
      <PrivacyRuleText>{t('whileContacting')}</PrivacyRuleText>
      <PrivacyRuleText>{t('whatYouProvideUs')}</PrivacyRuleText>
      <TitleSection>{t('howWeUseInfo')}</TitleSection>
      <PrivacyRuleText>{t('waysWeUseInfo')}</PrivacyRuleText>
      <SectionList>{t('maintainWebsite')}</SectionList>
      <SectionList>{t('improveWebsite')}</SectionList>
      <SectionList>{t('understandUseWebsite')}</SectionList>
      <SectionList>{t('developNewFunctionality')}</SectionList>
      <SectionList>{t('improveWebsite')}</SectionList>
      <SectionList>{t('communicateWithYou')}</SectionList>
      <SectionList>{t('sendEmail')}</SectionList>
      <SectionList>{t('findAndPrevent')}</SectionList>
      <SectionList>{t('logFiles')}</SectionList>
      <SectionList>{t('usingLogFiles')}</SectionList>
      <TitleSection>{t('cookiesAndBeacons')}</TitleSection>
      <PrivacyRuleText>{t('aboutCookies')}</PrivacyRuleText>
      <TitleSection>{t('advertisingPartners')}</TitleSection>
      <PrivacyRuleText>{t('aboutList')}</PrivacyRuleText>
      <PrivacyRuleText>{t('thirdParty')}</PrivacyRuleText>
      <PrivacyRuleText>{t('itahNoControl')}</PrivacyRuleText>
      <TitleSection>{t('thirdPartyPolicy')}</TitleSection>
      <PrivacyRuleText>{t('itahPrivacyPolicyNotApplyOthers')}</PrivacyRuleText>
      <PrivacyRuleText>{t('disableCookies')}</PrivacyRuleText>
      <PrivacyRuleText>{t('doNotSellPrivacy')}</PrivacyRuleText>
      <SectionList>{t('discloseData')}</SectionList>
      <SectionList>{t('deleteDataBusinessCollected')}</SectionList>
      <SectionList>{t('personalDataSell')}</SectionList>
      <SectionList>{t('timeToRespondYou')}</SectionList>
      <SectionList>{t('dataProtectionRights')}</SectionList>
      <PrivacyRuleText>{t('ifYouAreAware')}</PrivacyRuleText>
      <SectionList>{t('rightToAccessData')}</SectionList>
      <SectionList>{t('correctInfo')}</SectionList>
      <SectionList>{t('eraseData')}</SectionList>
      <SectionList>{t('objectData')}</SectionList>
      <SectionList>{t('rightToRequestInfoSend')}</SectionList>
      <PrivacyRuleText>{t('timeToRespondYou')}</PrivacyRuleText>
      <TitleSection>{t('childrenInfo')}</TitleSection>
      <PrivacyRuleText>{t('protectionChildren')}</PrivacyRuleText>
      <PrivacyRuleText>{t('childrenUnderEleven')}</PrivacyRuleText>
    </PrivacyPolicyWrapper>    
  );
};
